import axios from 'axios';
axios.defaults.withCredentials = true;

/* Addition 객체 정의 */
export var Addition = function(){
  /** 커맨드 명 */
	this.cmdName = "";

  /** 현재페이지 */
	this.pageIndex = 1;
    
  /** 페이지갯수 */
	this.pageUnit = 10;
    
  /** 페이지사이즈 */
	this.pageSize = 10;

  /** 검색된 결과물 총 개수 */
	this.totalCnt = 0;

  /** 페이지 처리 여부 */
	this.pageYn = "N";

  /** firstIndex */
	this.firstIndex = 1;

  /** lastIndex */
  this.lastIndex = 1;

  /** recordCountPerPage */
  this.recordCountPerPage = 10;

}
Addition.prototype = {
	setCmdName: function (cmdName) {
		this.cmdName = cmdName;
	},
	getCmdName: function () {
		return this.cmdName;
	},
	setPageIndex: function (pageIndex) {
		this.pageIndex = pageIndex;
	},
	getPageIndex: function () {
		return this.pageIndex;
	},
	setPageUnit: function (pageUnit) {
		this.pageUnit = pageUnit;
	},
	getPageUnit: function () {
		return this.pageUnit;
	},
	setPageSize: function (pageSize) {
		this.pageSize = pageSize;
	},
	getPageSize: function () {
		return this.pageSize;
	},
	setTotalCnt: function (totalCnt) {
		this.totalCnt = totalCnt;
	},
	getTotalCnt: function () {
		return this.totalCnt;
	},
	setPageYn: function (pageYn) {
		this.pageYn = pageYn;
	},
	getPageYn: function () {
		return this.pageYn;
	},
	setFirstIndex: function (firstIndex) {
		this.firstIndex = firstIndex;
	},
	getFirstIndex: function () {
		return this.firstIndex;
	},
	setLastIndex: function (lastIndex) {
		this.lastIndex = lastIndex;
	},
	getLastIndex: function () {
		return this.lastIndex;
	},
	setRecordCountPerPage: function (recordCountPerPage) {
		this.recordCountPerPage = recordCountPerPage;
	},
	getRecordCountPerPage: function () {
		return this.recordCountPerPage;
	}
}

/* Param 객체 정의 */
export var Param = function(){
	this.paraName = "";
	this.paraValue = "";
}
Param.prototype = {
	setParaName: function (paraName) {
		this.paraName = paraName;
	},
	getParaName: function () {
		return this.paraName;
	},
	setParaValue: function (paraValue) {
		this.paraValue = paraValue;
	},
	getParaValue: function () {
		return this.paraValue;
	}
}

/* ReqInputMsg 객체 정의 */
export var ReqInputMsg = function(){
	this.addition = new Addition();
	this.paramList = [];
}
ReqInputMsg.prototype = {
	setAddition: function (addition) {
		this.addition = addition;
	},
	getAddition: function () {
		return this.addition;
	},
	setParamList: function (paramList) {
		this.paramList = paramList;
	},
	getParamList: function () {
		return this.paramList;
	},
	addParam: function (param) {
		if (this.paramList === undefined || this.paramList === null) {
			this.paramList = [];
		}
		return this.paramList.push(param);
	}
}
export function callCmd(reqInputMsg, urlNm) {
// function callCmd(reqInputMsg) {
	//var returnObj = new Object();
    
	var url = process.env.REACT_APP_URL + '/' + urlNm + '/' + reqInputMsg.getAddition().getCmdName();
	//console.log(url);

	return axios({
		method: 'post',
		url: url,
		headers: {
			'Content-Type': 'application/json',
		},
		data: JSON.stringify(reqInputMsg)
	})
	.then((res) => {
		// handle success
		if (process.env.REACT_APP_LOG === "1") {
			console.log(reqInputMsg.getAddition().getCmdName(), res.data);
		}
		
		// returnObj = res.data
		return res.data;
	});
	// .catch((err) => {
	// 	// handle error
	// 	console.log('err', err);
	// 	return returnObj = err;
	// });
}

